import React from "react";
import { useLocation } from "react-router-dom";
import Footer from "./footer";
import AdminFooter from "./adminFooter";
const MainFooter = () => {
  const location = useLocation();
  return (
    <div>
      {" "}
      {location?.pathname === "/admin-dashboard" ||
      location?.pathname === "/admin/nfts" ||
      location?.pathname === "/admin/reports-list" ||
      location?.pathname === "/admin/nfts" ||
      location?.pathname === "/admin/transactions-list" ||
      location?.pathname === "/admin-login" ? (
        <AdminFooter />
      ) : (
        <Footer />
      )}
    </div>
  );
};

export default MainFooter;
